import { api } from './api';

export const allocationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllocationsHistoryCursor: build.infiniteQuery<
      any,
      number,
      { limit: number; eventTypes?: string[]; cursor?: string }
    >({
      infiniteQueryOptions: {
        initialPageParam: { limit: 20, eventTypes: [], cursor: undefined },
        getNextPageParam: (lastPage, _allPages, lastPageParam, _allPageParams) => {
          if (!lastPage.nextCursor) {
            return undefined;
          }
          return {
            ...lastPageParam,
            cursor: lastPage.nextCursor,
          };
        },
      },
      query: ({ pageParam: { eventTypes, limit, cursor } }) => {
        const params = new URLSearchParams();
        if (eventTypes && eventTypes.length > 0) {
          eventTypes.forEach((type) => params.append('eventTypes', type));
        }
        params.append('limit', limit.toString());
        if (cursor) {
          params.append('cursor', cursor);
        }
        return { url: `v2/accounts/history/allocation?${params.toString()}` };
      },
      providesTags: () => [{ type: 'AllocationHistory' }],
    }),
  }),
});

export const { useGetAllocationsHistoryCursorInfiniteQuery } = allocationsApi;
